import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Geo
export const getGeoService = (params) => {
  return http.get(`${base_url}/geo`, { params });
};
// End Geo
